import styled from 'styled-components';

import {
  colorBlack900,
  colorGraySemiLight,
  colorGrey400,
  colorPrimary,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
} from 'styles';

export const Wrapper = styled.section`
  width: 100%;
  margin-top: 16px;
  padding: 16px;
  background: ${colorWhite};
  border-radius: 12px;
  scroll-margin-top: 64px;

  @media ${mediaQueryMobileLargeMin} {
    padding: 24px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 0;

  @media ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    min-height: 48px;
  }
`;

export const Title = styled.h2`
  margin: 0;
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: ${colorBlack900};

  @media ${mediaQueryMobileLargeMin} {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const TableScrollWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  & table {
    min-width: 288px;
  }
`;

export const Empty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 80px;
  padding: 16px 0;
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 24px;
  color: #93a1a9;
`;

export const DownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 8px 0;
  border: 0;
  background: transparent;
  color: ${colorPrimary};
  font-family: ${fontFamilySecondary};
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  cursor: pointer;

  svg {
    flex-shrink: 0;
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const Source = styled.p`
  margin: 16px 0 0;
  padding-top: 0;
  font-size: 14px;
  line-height: 18px;
  color: ${colorGrey400};
  text-align: left;
`;

export const YearEndRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 0 0;
  font-size: 14px;
  line-height: 24px;
  color: ${colorBlack900};
  box-shadow: inset 0 1px 0 ${colorGraySemiLight};

  @media ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
`;

export const YearEndLabel = styled.span`
  font-weight: 700;
  min-width: 0;
`;

export const YearEndValues = styled.span`
  font-weight: 700;
  flex-shrink: 0;
`;
